import * as React from "react";
import { Form, Input, Row, Col, Card } from "antd";
import { createRequest, updateRequest } from "@actions/supplier";
import { Supplier } from "@models/supplier";
import { FormattedMessage } from "react-intl";
import withFormWrapper from "../../hocs/withFormWrapper";
import { Checkbox } from "antd";

interface PropsFromState {
  loading: boolean;
  errors?: string;
  form: any;
  supplier?: Supplier;
}

interface PropsFromDispatch {
  createRequest: typeof createRequest;
  updateRequest: typeof updateRequest;
}

type SupplierFormAllProps = PropsFromState & PropsFromDispatch;

type accountInformationType = {
  iban: string;
  firstname: string;
  lastname: string;
};

type SupplierFormStateShape = {
  name: string;
  share: number;
  address: string;
  postal_code: string;
  economic_code: string;
  unique_identifier: string;
  value_added_tax: number;
  auto_payment: boolean;
  account_configuration: accountInformationType;
};

const FlagOptions = [
  {
    label: (
      <FormattedMessage id="app.auto_payment" defaultMessage={`Auto Payment`} />
    ),
    value: true
  }
];

class SupplierForm extends React.Component<
  SupplierFormAllProps,
  SupplierFormStateShape
> {
  constructor(props) {
    super(props);
    const { supplier } = props;
    this.state = {
      ...this.getStateFromProps(supplier)
    };
  }

  getStateFromProps = (supplier: Supplier | null): object => {
    //TODO check just once and set default values instead of inline if for each property!
    const obj = supplier || {};
    return {
      name: obj.name || "",
      share: obj && obj.share ? parseInt(obj.share) : "",
      address: obj.address || "",
      postal_code: obj.postal_code || "",
      economic_code: obj.economic_code || "",
      unique_identifier: obj.unique_identifier || "",
      auto_payment: obj.auto_payment || false,
      value_added_tax:
        obj && obj.value_added_tax ? parseInt(obj.value_added_tax) : "",
      account_configuration: obj.account_configuration || {
        iban: "",
        firstname: "",
        lastname: ""
      },
      id: obj.id
    };
  };

  /**
   * called from FormModal HOC
   * returns all the values should be passed in payload
   */

  getValues = () => {
    let returnValues = null;
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        returnValues = {
          ...values,
          auto_payment: this.state.auto_payment
        };
      }
    });

    return {
      payload: returnValues,
      id: this.props.supplier ? this.props.supplier.id : null
    };
  };

  onChangePayment = () => {
    this.setState({
      auto_payment: !this.state.auto_payment
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    return (
      <Form className={"supplier-form"}>
        <Row>
          <Col span={12}>
            <Form.Item
              label={<FormattedMessage id="app.name" defaultMessage={`Name`} />}
            >
              {getFieldDecorator("name", {
                initialValue: this.state.name,
                rules: [
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.name_is_required"
                        defaultMessage={`Name is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.unique_identifier"
                  defaultMessage={`Unique Identifier`}
                />
              }
            >
              {getFieldDecorator("unique_identifier", {
                initialValue: this.state.unique_identifier
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage id="app.share" defaultMessage={`Share`} />
              }
            >
              {getFieldDecorator("share", {
                initialValue: this.state.share,
                rules: [
                  {
                    required: true,
                    message: (
                      <FormattedMessage
                        id="app.share_is_required"
                        defaultMessage={`Share is required!`}
                      />
                    )
                  }
                ]
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.value_added_tax"
                  defaultMessage={`Value Added Tax`}
                />
              }
            >
              {getFieldDecorator("value_added_tax", {
                initialValue: this.state.value_added_tax
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.economic_code"
                  defaultMessage={`Economic code`}
                />
              }
            >
              {getFieldDecorator("economic_code", {
                initialValue: this.state.economic_code
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.postal_code"
                  defaultMessage={`Postal code`}
                />
              }
            >
              {getFieldDecorator("postal_code", {
                initialValue: this.state.postal_code
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage id="app.address" defaultMessage={`Address`} />
              }
            >
              {getFieldDecorator("address", {
                initialValue: this.state.address
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={24}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.card_information"
                  defaultMessage={`Card Information`}
                />
              }
            ></Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage id="app.name" defaultMessage={`Card Name`} />
              }
            >
              {getFieldDecorator("account_configuration.firstname", {
                initialValue: this.state.account_configuration.firstname
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage
                  id="app.last_name"
                  defaultMessage={`Card LastName`}
                />
              }
            >
              {getFieldDecorator("account_configuration.lastname", {
                initialValue: this.state.account_configuration.lastname
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label={
                <FormattedMessage id="app.iban" defaultMessage={`Card IBAN`} />
              }
            >
              {getFieldDecorator("account_configuration.iban", {
                initialValue: this.state.account_configuration.iban
              })(<Input />)}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={20}>
            <Checkbox
              checked={this.state.auto_payment}
              onChange={this.onChangePayment}
            >
              <FormattedMessage
                id="app.auto_payment"
                defaultMessage={`Auto Payment`}
              />
            </Checkbox>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default withFormWrapper(
  Form.create({ name: "supplier-form" })(SupplierForm)
);
